import { confirmWarningConfig } from "@/configuration/confirmConfigurations";

export default {
  name: "ThirdPartySystemEdit",
  data: () => ({
    isValid: false,
    modulesTypes: ["Events", "POIs", "News"],
    typeIds: [
      "Allgäuer-Zeitung-ID",
      "DestinationOne-ID",
      "Feratel-ID",
      "Feratel-CPS-ID",
      "Infomax-ID",
      "Tramino-ID",
      "Tramino-ID-Tourismus",
      "OutdoorActive-ID",
      "Eventim-ID"
    ],
    defaultModule: { type: "", description: "" }
  }),
  props: ["showEditDialog", "editedItem"],
  computed: {
    cShowEditDialog: {
      get() {
        return this.showEditDialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    },
    formTitle() {
      if (this.editedItem?.name) {
        return `Fremdsystem "${this.editedItem?.name}" bearbeiten`;
      }
      return "Neues Fremdsystem anlegen";
    },
    modules() {
      return this.editedItem.modules;
    },
    cModuleTypes() {
      return this.modulesTypes.map(type => {
        return {
          text: type,
          value: type,
          disabled: !this.availableModuleTypes.includes(type)
        };
      });
    },
    availableModuleTypes() {
      if (!this.editedItem.modules?.length) {
        return this.modulesTypes;
      }
      return this.modulesTypes.filter(
        moduleType =>
          !this.editedItem.modules.some(module => module.type === moduleType)
      );
    }
  },
  methods: {
    async close() {
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie alle Änderungen verwerfen wollen?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        this.cShowEditDialog = false;
      }
    },
    addModule() {
      this.modules.push({ ...this.defaultModule });
    },
    removeModule(type) {
      this.editedItem.modules = this.editedItem.modules.filter(
        module => module.type !== type
      );
    }
  }
};
